export default "__VITE_ASSET__Wyyx3dbw__"